import { render, staticRenderFns } from "./JisoLogo.vue?vue&type=template&id=1505f6f0&scoped=true&"
var script = {}
import style0 from "./JisoLogo.vue?vue&type=style&index=0&id=1505f6f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1505f6f0",
  null
  
)

export default component.exports